export const rootDoc = document.querySelector(":root");
export function _(id) {
    return document.getElementById(id);
}
export function $(parent, selector) {
    return Array.from(parent.querySelectorAll(selector));
}
